import React from 'react';
import Skeleton from 'components/Skeleton';
import { StyledCard } from '../LearnerHome.styles';

interface UserProfile {
  name: string;
  email: string;
}

interface ProfileCardProps {
  loading: boolean;
  user?: UserProfile;
}

const ProfileCard: React.FC<ProfileCardProps> = ({ loading, user }) => {
  if (loading) {
    return <Skeleton type='profile-card' container={StyledCard} />;
  }

  if (!user) {
    return <StyledCard>No user data available.</StyledCard>;
  }

  return (
    <StyledCard>
      <h3>{user.name}</h3>
      <p>{user.email}</p>
    </StyledCard>
  );
};

export default ProfileCard;
